import styles from './index.module.sass';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const Loading = ({
  inline = false,
  className,
}: {
  inline?: boolean;
  className?: string;
}) => {
  const loadingClass = cx({
    loading: true,
    inline,
  });
  return (
    <div className={`${loadingClass} ${className ?? ''}`}>
      <div className={styles.dots} />
    </div>
  );
};

export default Loading;
